export default __webpack_public_path__ + "static/media/Nainital golf course.a6131e6e.jpg";